import { AbstractConnector } from '@web3-react/abstract-connector';
import LedgerHQProvider from './provider';
import { asyncToGenerator, checkError, isHIDSupported } from './utils';
import invariant from 'tiny-invariant';

class LedgerHQConnector extends AbstractConnector {
    constructor(ref) {
        let { chainId, url, getPath } = ref;
        super({
            supportedChainIds: [chainId],
        });
        this.chainId = chainId;
        this.url = url;
        this.handleDisconnect = this.handleDisconnect.bind(this);
        this.getPath = getPath;
    }

    handleDisconnect() {
        this.emitDeactivate();
    }

    isSupported() {
        return isHIDSupported();
    }

    getProviderInstance() {
        const provider = new LedgerHQProvider(this.url, this.chainId, this.getPath);
        return provider;
    }

    activate() {
        const temp_this = this;

        return asyncToGenerator(function* () {
            try {
                if (!temp_this.provider) {
                    temp_this.provider = yield temp_this.getProviderInstance();
                }

                temp_this.provider.on('disconnect', temp_this.handleDisconnect);

                const account = yield temp_this.provider.enable();
                return {
                    provider: temp_this.provider,
                    account,
                };
            } catch (error) {
                return checkError(error);
            }
        })();
    }

    getProvider() {
        return this.provider;
    }

    getChainId() {
        return this.chainId;
    }

    getAccount() {
        !this.provider ? invariant(false, 'Provider is not defined') : void 0;
        return this.provider.getAddress();
    }

    deactivate() {
        !this.provider ? invariant(false, 'Provider is not defined') : void 0;
        this.provider.removeListener('disconnect', this.handleDisconnect);
    }
}

export default LedgerHQConnector;
